export enum PsatSteps {
  rate = 1,
  comment1 = 2,
  finish = 3,
  finishCall = 4,
}
